module.exports = __webpack_public_path__ + "static/media/bi_symbol_image_black_m.5b3ba551.png";